import Cookies from "js-cookie";
import GlobalStore from "@/store";
import ShopType from "@/enum/ShopType";
import md5 from "@/utils/md5";

/**
 * 京东安全审计
 * @see https://jos.jd.com/commondoc.html?listId=104
 */
export function JdSecurityInit(globalStore: typeof GlobalStore) {
    const currentShopId = globalStore.currentUser.shopId;
    const currentShop = globalStore.shopMapping.get(currentShopId);

    const hasJd = globalStore.allowedShops.some((shop) =>
        [ShopType.JD, ShopType.JD_DROP_SHIPPING_SUPPLIER].includes(shop.type),
    );

    if (!hasJd) return;

    const isJdUser = currentShop.type === ShopType.JD;
    const sellerUserName = isJdUser ? globalStore.currentUser.username : md5(globalStore.currentUser.username);

    // @ts-ignore
    window.pin = sellerUserName;

    setTimeout(() => {
        getJdEid((eid, fp, udfp) => {
            Cookies.set("eid", eid, {
                domain: ".fahuoyi.com",
                path: "/",
                sameSite: "None",
                secure: true,
                expires: 365,
            });
            Cookies.set("fp", fp, { domain: ".fahuoyi.com", path: "/", sameSite: "None", secure: true, expires: 365 });
            Cookies.set("token", udfp.token, {
                domain: ".fahuoyi.com",
                path: "/",
                sameSite: "None",
                secure: true,
                expires: 365,
            });

            console.log("eid:", eid, " fp:", fp, " token:", udfp.token);
        });
    }, 1000);
}
